import Cookies from 'js-cookie';

// Simple JWT Token Management for API calls

/**
 * Store JWT token in cookies
 * @param {string} token - JWT token
 */
export const setAuthToken = (data,token) => {
  if (token) {
    Cookies.set('user_id', data.id, { expires: 7 });
    Cookies.set('auth_token', token, { expires: 7 }); 

  }
};

/**
 * Get JWT token from cookies
 * @returns {string|null} - JWT token or null
 */
export const getAuthToken = () => {
  return Cookies.get('auth_token') || null;
};

/**
 * Remove JWT token from cookies
 */
export const removeAuthToken = () => {
  Cookies.remove('auth_token');
  // Also remove old cookie-based auth data
  Cookies.remove('user_id');
  Cookies.remove('user_name');
  Cookies.remove('user_phone');
  Cookies.remove('user_balance');
};

/**
 * Check if user has a token (simple check, no parsing)
 * @returns {boolean} - True if token exists
 */
export const isAuthenticated = () => {
  const token = getAuthToken();
  return token !== null && token !== '';
};

/**
 * Get authorization header for API requests
 * @returns {object} - Authorization header object
 */
export const getAuthHeader = () => {
  const token = getAuthToken();
  return token ? { Authorization: `Bearer ${token}` } : {};
};

/**
 * Store user data after successful login
 * @param {object} userData - User data from login response
 * @param {string} token - JWT token
 */
export const storeUserData = (userData, token) => {
  // Store JWT token
  if (token) {
    setAuthToken(token);
  }
  
  // Also store user data in cookies for backward compatibility
  if (userData.id) Cookies.set('user_id', userData.id, { expires: 7 });
  if (userData.name) Cookies.set('user_name', userData.name, { expires: 7 });
  if (userData.phone) Cookies.set('user_phone', userData.phone, { expires: 7 });
  if (userData.balance || userData.balacnce) {
    Cookies.set('user_balance', userData.balance || userData.balacnce, { expires: 7 });
  }
};

/**
 * Clear all authentication data
 */
export const clearAuthData = () => {
  removeAuthToken();
};